import { _ as _taggedTemplateLiteralLoose } from './taggedTemplateLiteralLoose-7a042257.esm.js';
import React, { forwardRef, useEffect } from 'react';
import { fetchAppOpenUrl } from '@growth/api-calls';
import { useApiCall } from '@growth/custom-hooks/useApiCall';
import { isIOSClient } from '@growth/user-agents';
import styled from 'styled-components';

var _templateObject;
var GI_APP_BRANCH_URL = 'https://go.ibi.bo/1N2eH2nUbhb';
var CtaButtonWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\twidth: 100%;\n\tpointer-events: ", ";\n\t", "\n"])), function (props) {
  return props.loading ? 'none' : null;
}, function (props) {
  if (props.sticky) {
    return "\n\t\t\t\tposition: sticky;\n\t\t\t\ttop: 0;\n\t\t\t\tz-index: 1000;\n\t\t\t";
  }
  if (props.wrapperCss) return props.wrapperCss;
  return null;
});
var AppDownloadCtaButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var CustomButton = _ref.CustomButton,
    onCtaClick = _ref.onCtaClick,
    afterLinkOpen = _ref.afterLinkOpen,
    linkDetails = _ref.linkDetails,
    onLinkApiFail = _ref.onLinkApiFail,
    sticky = _ref.sticky,
    bannerType = _ref.bannerType,
    wrapperCss = _ref.wrapperCss;
  var _useApiCall = useApiCall(fetchAppOpenUrl),
    appLink = _useApiCall[0],
    fetchAppLink = _useApiCall[1];
  var loading = appLink.loading,
    data = appLink.data,
    completed = appLink.completed,
    error = appLink.error;
  var handleDownloadClick = function handleDownloadClick(e) {
    var _linkDetails$extraDat, _linkDetails$extraDat2;
    // app branch.io link is fetching
    if (loading) return;
    // callback to parent component
    if (onCtaClick) {
      var isCustomHandlerPresent = onCtaClick(e) || false;
      if (isCustomHandlerPresent) {
        return;
      }
    }

    /*
     * We get godata and tagid from lobs on "linkDetails" props
     * we pass this to api to generate the dynamic branch.io link
     * for all lobs
     * */
    var apiPayload = {
      tagid: linkDetails == null ? void 0 : linkDetails.tagid,
      godata: linkDetails == null ? void 0 : linkDetails.godata,
      campaign: linkDetails == null ? void 0 : linkDetails.campaign,
      loginReq: (linkDetails == null ? void 0 : linkDetails.loginReq) || true,
      referral_flow: (linkDetails == null || (_linkDetails$extraDat = linkDetails.extraData) == null ? void 0 : _linkDetails$extraDat.showTimer) || false,
      // this is used to send gocash to the user for timer based mweb2app
      trafficSource: (linkDetails == null || (_linkDetails$extraDat2 = linkDetails.extraData) == null ? void 0 : _linkDetails$extraDat2.trafficSource) || ''
    };
    fetchAppLink({
      apiPayload: apiPayload
    });
  };
  useEffect(function () {
    if (completed) {
      var _data$data;
      // branch.io link with auth context
      // if api timeout/fails will fallback to hardcoded branch link
      var fallbackLink = GI_APP_BRANCH_URL + "?utm_campaign=" + (linkDetails == null ? void 0 : linkDetails.campaign) + "-fallback";
      var branchLink = (data == null || (_data$data = data.data) == null ? void 0 : _data$data.link) || fallbackLink;

      /* ios browsers does not give 100% support to open a blank tab programatically */
      // https://stackoverflow.com/questions/4907843/open-a-url-in-a-new-tab-and-not-a-new-window/4907854#4907854
      if (!isIOSClient()) {
        window.open(branchLink, '_blank');
      } else {
        window.location.href = branchLink;
      }
      if (afterLinkOpen) afterLinkOpen();
    }
    if (error) {
      if (onLinkApiFail) onLinkApiFail();
    }
  }, [completed, error]);
  return /*#__PURE__*/React.createElement(CtaButtonWrapper, {
    ref: ref,
    sticky: sticky,
    onClick: handleDownloadClick,
    loading: loading ? 1 : 0,
    id: "id_app_" + (bannerType || 'banner'),
    wrapperCss: wrapperCss
  }, CustomButton);
});
AppDownloadCtaButton.displayName = 'AppDownloadCtaButton';
AppDownloadCtaButton.defaultProps = {
  CustomButton: undefined,
  afterLinkOpen: undefined,
  onCtaClick: function onCtaClick() {},
  onLinkApiFail: function onLinkApiFail() {}
};

export { AppDownloadCtaButton as A };
